import React, { Component } from 'react';

import axios from 'axios';

import { Modal, Button } from 'react-bootstrap';

require(`../assets/${process.env.PAGE}/css/components/save-step-button.css`)

class SaveStepButton extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            loading: false
        };

        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.saveStep = this.saveStep.bind(this);
    }

    componentDidUpdate(prevProps, prevState){
        if (prevState.modal === false &&
            this.state.modal === true &&
            this.state.loading){
                this.setState({loading: false});
        }
    }

    showModal() {
        this.setState({ modal: true });
    }

    hideModal() {
        this.setState({ modal: false });
    }

    saveStep() {

        this.setState({loading: true});

        const ROOT_URL = process.env.API_URL;
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        axios.post(`${ROOT_URL}/leads/save_steps`, {}, config)
        .then(res => {
            this.setState({ modal: false });
        }
        ).catch(err => {
            this.setState({ modal: false });
        });
    }

    render() {
        const { modal, loading } = this.state;
        return (
            <div>
                <button
                    onClick={this.showModal}
                    className={'btn pd-simple-button save-step-button'}
                >
                    <img className="save-step-icon" src={require(`../assets/${process.env.PAGE}/img/save.png`)}/>
                    Continuar luego
                </button>
                <Modal className="custom-modal" show={modal} onHide={this.hideModal} bsSize="large">
                        <Modal.Header>
                            <Modal.Title>Guardar el estado de la solicitud</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {loading ? 'guardando solicitud' : 'Si elegís guardar, te enviaremos un mail y SMS para que puedas continuar luego con tu solicitud.'}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button 
                                type="submit" 
                                bsStyle="success" 
                                onClick={this.saveStep} 
                                disabled={loading}>
                                    Guardar
                            </Button>
                            <Button onClick={this.hideModal}>Cancelar</Button>
                        </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default SaveStepButton;


/** WEBPACK FOOTER **
 ** ./src/components/SaveStepButton.js
 **/